import moment, { Moment, MomentInput } from 'moment';

export const getFormattedDate = (date: MomentInput): string =>
  moment(date).format('DD/MM/YYYY');

export const getTextFormattedDate = (date: number | undefined): string =>
  moment(date).format('LL');

export const isMidnight = (date: Moment): boolean =>
  date.hours() === 0 && date.minutes() === 0;